<template>
  <div id="app">
    <os-nav v-if="$store.state.navShow" id="osNav" />
    <tag-breadcrumb v-if="$store.state.navShow" class="breadcrumb" />
    <modify-password-dialog />
    <div :class="['page', { page1: $store.state.navShow }]">
      <div class="container">
        <transition
          appear
          :enter-active-class="!$store.state.navShow ? '' : 'animate__animated pxq__fadeInRight'"
        >
          <router-view />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import osNav from "@/components/osNav/osNav";
import tagBreadcrumb from "@/components/osNav/breadcrumb/tag-breadcrumb.vue";
import addRoutersFn from "@/utils/router";
import modifyPasswordDialog from "@/components/modify-password-dialog.vue";

export default {
  name: "App",
  components: { osNav, tagBreadcrumb, modifyPasswordDialog },
  created() {
    addRoutersFn();
  },
};
</script>

<style>
@import "./assets/css/base.css";
@import "./assets/font/icon/iconfont.css";
#app {
  min-height: 100vh;
}

#osNav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  width: 14vw;
  height: 100%;
}

.page {
  display: flex;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  /* z-index: 9; */
}

.page1 {
  padding: 130px 0 0 0;
  padding-left: calc(14vw + 20px);
}

.container {
  align-items: stretch;

  width: 100%;
  background: #fff;
  display: block;
  box-sizing: border-box;
  overflow: hidden;
}

.breadcrumb {
  position: fixed;
  z-index: 99;
  top: 60px;
  left: calc(16vw + 20px);

  display: flex;
  width: calc(84vw - 40px);
  padding: 15px 0 0 0;
  background-color: rgb(245, 245, 245);
}

#tagBreadcrumb > span {
  margin-right: 20px;
}

.pxq__fadeInRight {
  -webkit-animation-name: pxqFadeInRight;
  animation-name: pxqFadeInRight;
}

@keyframes pxqFadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(20%, 0, 0);
    transform: translate3d(20%, 0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue